var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 126,
    viewBox: "0 0 151 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.077 0H12.9446C5.7955 0 0 5.909 0 13.1981V112.491C0 119.78 5.7955 125.689 12.9446 125.689H137.077C144.226 125.689 150.021 119.78 150.021 112.491V13.1981C150.021 5.909 144.226 0 137.077 0Z",
    fill: "#3E85C7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1123_639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.137 31.7347L39.5928 13.4885L32.2603 20.6308L77.6639 52.1003L75.9911 54.5135L94.8039 36.8477L96.3894 37.3418L97.2633 34.5383L98.137 31.7347Z",
    fill: "#FFC34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3558 61.7215L117.703 108.208L125 101.1L106.45 41.2998L103.645 42.1698V42.1696V42.1698L100.841 43.0395L101.298 44.5125L83.3644 62.4087L80.9294 64.0507L82.3405 66.1431L86.3558 61.7215Z",
    fill: "#FF884D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7627 93.4513L55.0601 112.512L60.53 107.765L62.9058 80.3151L44.7627 93.4513Z",
    fill: "#FF884D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7625 91.0439L25 81.2678L29.5979 75.7165L56.4157 74.5648L41.7625 91.0439Z",
    fill: "#FFC34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.378 18.7195L108.535 29.7896L88.7035 54.1906L37.6566 99.19C37.6507 99.1607 37.6546 99.1372 37.6585 99.1196L38.2771 95.494C38.6138 93.5305 39.4458 91.6688 40.685 90.1105L54.2026 73.0966C68.4816 56.161 81.5724 42.9175 97.9696 28.8147L101.072 26.1462C101.072 26.1462 117.266 18.604 117.378 18.7195V18.7195Z",
    fill: "#E6F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.879 37.2424L109.13 40.2729C94.6005 56.2942 81.0183 69.0306 63.7127 82.8594L45.6946 96.4181C44.428 97.3715 43.0067 98.0508 41.4719 98.4403L37.9012 99.3448C37.8816 99.3506 37.8503 99.3565 37.8151 99.3487C37.7622 99.2978 37.7074 99.2449 37.6565 99.1921V99.1901L90.5444 47.385L108.521 29.776L116.517 23.5342C116.629 23.6478 111.879 37.2424 111.879 37.2424V37.2424Z",
    fill: "#B3D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.088 16.4875L108.521 29.776L108.505 29.7603C106.924 28.1276 104.868 26.957 102.55 26.4617L101.072 26.1465L108.094 20.1072C110.616 17.9381 113.707 16.5227 117.037 16.0176L119.603 15.6261C120.375 15.5087 121.132 15.7025 121.743 16.1527C121.808 16.2114 121.87 16.2721 121.933 16.3328C121.986 16.3837 122.037 16.4346 122.088 16.4875V16.4875Z",
    fill: "#99AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.883 18.9912L122.425 21.5478C121.83 24.8621 120.336 27.918 118.102 30.3807L111.879 37.2423L111.603 35.7564C111.174 33.4542 110.08 31.3889 108.521 29.7758L122.088 16.4873C122.2 16.6009 122.307 16.7183 122.413 16.8397C122.848 17.4622 123.022 18.2238 122.883 18.9912V18.9912Z",
    fill: "#8080FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1123_639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(25 13)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.6c27fcd5dc80642d27e9da86cb637882.svg";
export { ForwardRef as ReactComponent };